import UserRoleMap from "@/components/Common/UserRoleMap";
import { Notification } from "element-ui";
import socket from "@/services/socket.service";

export default {
  name: "TheCustomerBasicData",

  components: { UserRoleMap },

  props: {
    user: {
      type: Object,
      default: () => ({})
    }
  },

  mounted() {
    this.handleConnectToSocketWhenUserLogged();
  },

  methods: {
    handleConnectToSocketWhenUserLogged() {
      if (!this.$store.getters["authorization/user"]) {
        return;
      }
      socket.handleSocketDisconnect(() => {
        setTimeout(() => {
          if (!socket.isSocketConnected()) {
            this.$store.dispatch("global/toogleServerSocketConnection", false);
            this.$router.push({ name: "PlatformConnections" });
            if (this.$store.getters["authorization/user"] !== null) {
              Notification.error({
                title: "Error",
                message: "Nastąpiło chwilowe rozłączenie z serwerem Online"
              });
            }
          }
        }, 2000);
      });
    }
  }
};
